/**
 * @desc pay模块
 */
import { trackEvent } from '@/omega/index';

export const pay_change_payment_ck_log = () => {
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_cart_exchange_payment_ck',
    eventLabel: '下单页支付方式切换点击',
  });
};

export const pay_add_card_ck_log = () => {
  trackEvent({
    eventId: 'sailing_c_e_paylistpage_add_card_ck',
    eventLabel: '支付列表页银行卡添加点击',
  });
};

// 计算按钮点击
export const pay_compute_btn_ck_log = (options) => {
  const { intercept_type = 0, order_cnt = '' } = options;
  trackEvent({
    eventId: 'sailing_c_e_requestpage_info_cart_pay_ck',
    eventLabel: '下单页支付点击',
    attrs: {
      intercept_type,
      order_cnt,
      button_type: 2,
    },
  });
};

// 支付按钮点击
export const pay_pay_btn_ck_log = (options) => {
  try {
    const {
      receiverList = [],
      priceInfo,
      payChannel,
      contractID,
      intercept_type,
    } = options;
    const order_cnt = receiverList.length;
    const { originalPrice, realPayPrice, discountTip, discountPrice } =
      priceInfo;

    trackEvent({
      eventId: 'sailing_c_e_requestpage_info_cart_pay_ck',
      eventLabel: '下单页支付点击',
      attrs: {
        intercept_type,
        order_cnt,
        contract_id: contractID,
        button_type: 1,
        pay_method: payChannel,
        discount: discountTip,
        discount_price: discountPrice,
        original_price: originalPrice,
        total_price: originalPrice,
        price: realPayPrice,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

// 支付结果
export const pay_pay_callback_log = (options) => {
  try {
    trackEvent({
      eventId: 'sailing_c_e_requestpage_info_cart_pay_callback_ck',
      eventLabel: '下单页支付点击去创建订单的结果',
      attrs: {
        ...options,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

// 下单页支付栏曝光
export const pay_info_cart_sw_log = (options) => {
  try {
    const { button_type, priceInfo = {} } = options;
    const {
      originalPrice = '',
      realPayPrice = '',
      discountTip = '',
      discountPrice = '',
      payChannel = '',
    } = priceInfo;
    trackEvent({
      eventId: 'sailing_c_e_requestpage_info_cart_common_sw',
      eventLabel: '下单页支付栏曝光',
      attrs: {
        button_type,
        pay_method: payChannel,
        discount: discountTip,
        discount_price: discountPrice,
        original_price: originalPrice,
        total_price: originalPrice,
        price: realPayPrice,
      },
    });
  } catch (err) {
    console.log(err);
  }
};
